export default "__VITE_PUBLIC_ASSET__8a79fa18__"